module.exports = __webpack_public_path__ + "img/Truppführer_B.42d6c1bc.svg";